
































































































































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { AffiliateCommissionsFilters } from "@/data/filters/affiliate";
import { AffiliateCommissionsSorters } from "@/data/sorters/affiliate";

// Types
import { IFilter, ISorter } from "@/models/tables";
import { IAccount } from "@/models/accounts";
import { IAffiliateProviderMethods } from "@/models/providers/affiliate";

@Component({
  components: {
    "commission-summary": () =>
      import("@/components/app/global/affiliate/commissionSummary.vue"),
    "commission-amount-tag": () =>
      import("@/components/app/global/affiliate/commissionAmountTag.vue"),
    "pending-commission-control": () =>
      import("@/components/app/global/affiliate/pendingCommissionControl.vue")
  }
})
export default class CommissionsHistoryTable extends Mixins(
  FilteringSortingTableStore,
  Context
) {
  // Inject

  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  @Prop({ default: 10 })
  public declare limit: number;

  @Prop({ default: "APCT1" })
  public declare id: string;

  // Data

  public dataModule = DataModules.AFFILIATES_COMMISSIONS;
  public dataModuleAction = "listPending";
  public filters: IFilter[] = AffiliateCommissionsFilters;
  public sorters: ISorter[] = AffiliateCommissionsSorters;
  public guardFunctionalities = ["list_affiliate_account_pending_commissions"];

  // Computed

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  // Life-cycle methods

  public async created() {
    if (!this.contentIsAvailable) return;
    this.getData();
  }

  // Methods

  public async reloadData() {
    this.getData({ ignoreStored: true });
  }

  // Overrides 'FilteringSortingTableStore' method

  public getStoreParams(payload: any): Promise<any> {
    return {
      ...payload,
      accountId: this.accountId
    };
  }
}
